<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">官网新闻管理</p>
    <div class="main-container">
      <div class="main-area">
        <Card class="sub-area">
          <p slot="title">官网新闻展示区内容</p>
          <a href="javascript:void(0)" slot="extra" @click="addNews()" style="margin-right: 20px">添加新闻</a>
            <ul class="list-group">
              <li class="list-group-item" v-for="(item, index) in newsList" :key="item.id">
                <Card class="app-content">
                  <div class="app-logo">
                    <img :src="item.titleImgUrl">
                  </div>
                  <div class="app-info">
                    <span style="font-size: 16px; font-weight: bold">{{item.mainTitle}}</span><br>
                    <span>类别: {{getName(item.newsCategory)}}</span><br>
                    <span>来源: {{item.source}}</span><br>
                    <span>发布时间: {{transDate(item.publicDate)}}</span>
                  </div>
                  <div class="app-handle">
                    <Button type="primary" @click="showNewsInfo(item.id)">新闻详情</Button>
                    <Button type="primary" @click="updateNewsInfo(item.id)">更新内容</Button>
                    <Button type="error" v-if="item.active === 1" @click="newsDown( index)">下架新闻</Button>
                    <Button type="primary" v-else @click="newsUp(index)">上架新闻</Button>
                    <Button type="error" @click="deleteNews(item.id, index)">删除新闻</Button>
                  </div>
                </Card>
              </li>
            </ul>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
    import draggable from "vuedraggable";
    import {adminRouter} from "../../router/admin";
    import {format2Sec} from "../../utils/format";

    export default {
        name: "newsManager",
        components: {
            draggable
        },
        data() {
            return {
                newsList: [],
                editable: false,
                isDragging: false,
                delayedDragging: false
            };
        },
        methods: {
            getName(num){
                switch (num) {
                    case 1:
                        return '公司新闻';
                    case 2:
                        return '行业动态';
                    case 3:
                        return '媒体报导';
                    default:
                        return '无';
                }
            },
            transDate(time){
                return format2Sec(time);
            },

            addNews(){
                let active = 'editNewsInfo';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("newsId", '');
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active,
                    });
                }
            },
            showNewsInfo(id){
                let active = 'newsInfo';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("newsId", id);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            },
            updateNewsInfo(id){
                let active = 'editNewsInfo';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("newsId", id);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            },
            newsUp(index){
                this.newsList[index].active = 1;
                this.setData(this.newsList[index]);
            },
            newsDown(index){
                this.newsList[index].active = 0;
                this.setData(this.newsList[index]);
            },
            deleteNews(id, index){
                this.$http.post('/zm/WMWebsite/deleteNewsInfos', {'id': id}).then(
                    res => {
                        this.$Message.success("成功删除！");
                        this.newsList.splice(index, 1);
                    },
                    err => {
                        this.$Message.error("提交失败！"+err.message);
                    }
                );
            },
            setData(obj){
                this.$http.post('/zm/WMWebsite/updateNewsInfos', obj).then(
                    res => {
                    },
                    err => {
                        this.$Message.error("提交失败！"+err.message);
                    }
                );
            }
        },

        activated() {
            this.$http.get('/zm/WMWebsite/queryNewsInfos').then(
                res => {
                    this.newsList = res.data.content;
                }
            );
        }
    };
</script>

<style>
  .main-container{
    background-color: #eeeeee;
    position: relative;
    width: 80%;
    margin-left: 10%;
  }
  .handle-area{
    width: 100%;
    position: relative;
    display: inline-block;
    background-color: whitesmoke;
  }
  .handle-button{
    float: right;
    position: relative;
    display: inline-block;
    margin: 8px 10px;
  }
  .handle-button button{
    margin-left: 6px;
  }
  .main-area{
    width: 100%;
    position: relative;
    display: inline-block;
  }
  .sub-area{
    width: 100%;
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
  }
  .sub-area .ivu-card-body{
    padding: 10px;
  }
  .sub-area .ivu-card-head p{
    font-size: 16px;
  }
  .list-group{
    list-style-type: none;
    min-height: 100px;
  }
  .sub-area .list-group-item{
    margin-bottom: 5px;
    border: 1px solid #eeeeee;
  }
  .app-content .ivu-card-body{
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: 5px;
    min-height: 100px;
  }
  .app-logo img{
    width: 100px;
    height: 100px;
  }
  .app-info{
    margin-left: 30px;
  }

  .app-handle{
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
  }

  .app-handle button{
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// newsManager.vue?51902a9d